import { render, staticRenderFns } from "./shareReadingList.vue?vue&type=template&id=58913354&scoped=true"
import script from "./shareReadingList.vue?vue&type=script&lang=js"
export * from "./shareReadingList.vue?vue&type=script&lang=js"
import style0 from "./shareReadingList.vue?vue&type=style&index=0&id=58913354&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58913354",
  null
  
)

export default component.exports